<template>
  <div class="languageOptions">
    <slot name="title">
      <p :class="titleClass" class="languageOptions__title">
        {{ title }}
      </p>
    </slot>
    <ul :class="listClass" class="languageOptions__list">
      <li v-for="option in options"
          :key="option"
          class="languageOptions__listItem"
          :class="{ active: option === selected }"
          :data-testid="`button_menuOption_${option}`"
          @click="()=> $emit('selected', option)"
      >
        <language-flag class="flag" :value="option" small />
        <span>{{ getLanguageCopy(option) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { AVAILABLE_COUNTRIES_FOR_LANGUAGES } from '@/scripts/constants/languages';
import LanguageFlag from './LanguageFlag.vue';

export default {
  name: 'LanguageSelectorList',

  components: {
    LanguageFlag,
  },

  props: {
    selected: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    listClass: {
      type: String,
      default: '',
    },
  },

  emits: ['selected'],

  methods: {
    getLanguageCopy(language) {
      const country = AVAILABLE_COUNTRIES_FOR_LANGUAGES.find(c => c.language === language);
      return country.languageLabel;
    },
  },
};
</script>


<style lang="scss" scoped>

.languageOptions {
  &__title {
    @extend %t1;
    @extend %-t_semi-bold;
    padding: map-get($sh-spacers-wuk, 3) map-get($sh-spacers-wuk, 2) map-get($sh-spacers-wuk, 2);

    @media screen and (min-width: $tablet-size) {
      display: none;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: $tablet-size) {
      padding: 1rem 0;
    }
  }

  &__listItem {
    @extend %t3;
    @extend %-t_medium;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: map-get($sh-spacers-wuk, 1);
    padding: 0.75rem map-get($sh-spacers-wuk, 2);
    cursor: pointer;

    &::v-deep {
      .sword-icon {
        &.svg-icon {
          height: 22px;
          width: 22px;
        }
      }
    }

    &:hover {
      background: $color-primary-100;
      color: $context-color-1;
    }

    &.active {
      background: $color-primary-500;
      color: $color-white;
    }
  }
}

</style>
